// Compare
import { defineStore } from 'pinia'

//const {$showToast} = useNuxtApp();
export const useCompareStore = defineStore('compare', {
    state: () => (
        {
        data: []
        }
    ),
    persist: true,


    getters: {
        compareList: (state) => {
            return state.data
        },
        isInCompare: (state) => ( product ) => {
            return state.data.find( item => item.id == product.id ) ? true : false;
        }
    },

    actions: {
        addToCompare (payload) {
            if ( getters.isInCompare( payload.product ) ) {
                // this._vm.$vToastify.removeToast();
                // this._vm.$vToastify.setSettings( {
                //     withBackdrop: false,
                //     position: "top-right",
                //     errorDuration: 2000
                // } );
                // this._vm.$vToastify.error( "Product has already been added to compare list." );
                const showToast = useNuxtApp();
                showToast("Product has already been added to compare list", "info", 1500);
                return;
            }

            state.data = [ ...state.data, payload.product ];

            this._vm.$vToastify.setSettings( {
                withBackdrop: false,
                position: "top-right",
                successDuration: 1500,
            } );
            // this._vm.$vToastify.success( "Product added to compare" );
            const showToast = useNuxtApp();
            showToast("Product added to compare", "success", 1500);
        },


        removeFromCompare (payload) {
            state.data = state.data.filter( item => item.id !== payload.product.id );
            this._vm.$vToastify.setSettings( {
                withBackdrop: false,
                position: "top-right",
                successDuration: 1500,
            } );
            // this._vm.$vToastify.success( "Product removed from compare" );
            const showToast = useNuxtApp();
            showToast("Product removed from compare", "info", 1500);
        },

        clearCompare () {
            state.data = [];
            this._vm.$vToastify.setSettings( {
                withBackdrop: false,
                position: "top-right",
                successDuration: 1500,
            } );
            // this._vm.$vToastify.success( "Compare list cleared" );
            const showToast = useNuxtApp();
            showToast("Compare list cleared", "info", 1500);
        }
    }

})